import { render, staticRenderFns } from "./ActivatePromocode.vue?vue&type=template&id=8b43c238"
import script from "./ActivatePromocode.vue?vue&type=script&lang=ts"
export * from "./ActivatePromocode.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports